import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    Stack,
    Link
} from "@mui/material";
import { colours } from "../../StyleConstants";

interface SecurityComplianceAlertProps {
    open: boolean;
    onClose: () => void;
    onAcknowledge: () => void;
    onReview: () => void;
}

const SecurityComplianceAlert: React.FC<SecurityComplianceAlertProps> = ({
    open,
    onClose,
    onAcknowledge,
    onReview,
}) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            BackdropProps={{
                sx: {
                    backdropFilter: "blur(6px)",
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                },
            }}
        >
            <Stack flexDirection="row" justifyContent="space-between">
                <DialogTitle variant="h5" fontWeight="600" color={colours.midnightBlue.blue}>
                    ACTION REQUIRED: Compliance with Security Standards
                </DialogTitle>
                <HighlightOffIcon  onClick={onClose}/>
            </Stack>

            <DialogContent dividers>
                <Typography variant="body1" gutterBottom>
                    You have indicated that you are <strong>NOT compliant</strong> with{" "}
                    <Link
                        href="https://csrc.nist.gov/pubs/sp/800/171/r3/final"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        NIST SP 800-171
                    </Link>{" "}
                    or the equivalent{" "}
                    <Link
                        href="https://www.iso.org/standard/27001"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        ISO/IEC 27001/27002
                    </Link>{" "}
                    standards, as required by the{" "}
                    <strong>NIH Security Best Practices for Users of Controlled-Access Data</strong>.
                </Typography>

                <Typography variant="body1" gutterBottom>
                    As a result, you cannot proceed with your <strong>Data Use Certification (DUC) application</strong> at this time.
                </Typography>

                <Typography variant="body1">
                    If you wish to apply in the future, you may return once your security measures are compliant. At that time, you will need to{" "}
                    <strong>start a new DUC application</strong>.
                </Typography>
            </DialogContent>
            <DialogActions
                sx={{
                    p: 3,
                    display: "flex",
                    justifyContent: "center",
                }}
            >
                <Stack direction="column" spacing={2} alignItems="center">
                    <Button
                        variant="primary"
                        onClick={onAcknowledge}
                    >
                        Acknowledge non-compliance and exit DUC application process
                    </Button>
                    <Button
                        variant="secondary"
                        onClick={onReview}
                    >
                        Review my selection of compliance
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

export default SecurityComplianceAlert;